import { apiFetch, readJson } from './client';

export interface ClientMentionContact {
  id: number;
  name: string;
  email: string;
  mobile?: string | null;
  description?: string | null;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  modifiedBy: string;
  modifiedAt: string;
}

export interface ClientMentionContactUpsert {
  name: string;
  email: string;
  mobile?: string | null;
  description?: string | null;
  isActive: boolean;
}

const base = '/api/admin/client-mention-contacts';

export async function listClientMentionContacts(): Promise<ClientMentionContact[]> {
  const res = await apiFetch(base);
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  return readJson<ClientMentionContact[]>(res);
}

export async function createClientMentionContact(
  body: ClientMentionContactUpsert
): Promise<ClientMentionContact> {
  const res = await apiFetch(base, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Create failed (${res.status})`);
  }
  return readJson<ClientMentionContact>(res);
}

export async function updateClientMentionContact(
  id: number,
  body: ClientMentionContactUpsert
): Promise<ClientMentionContact> {
  const res = await apiFetch(`${base}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Update failed (${res.status})`);
  }
  return readJson<ClientMentionContact>(res);
}

export async function deleteClientMentionContact(id: number): Promise<void> {
  const res = await apiFetch(`${base}/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`Delete failed (${res.status})`);
}
